import React from 'react';

interface IProps {
  className?: string;
  onClick?: () => void;
}

function MirIcon(props: IProps): JSX.Element {
  return <div {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="12"
      viewBox="0 0 400 120"
    >
      <defs>
        <linearGradient
          id="linearGradient-1"
          x1="100%"
          x2="0%"
          y1="62.904%"
          y2="62.904%"
        >
          <stop offset="0%" stopColor="#1F5CD7" />
          <stop offset="100%" stopColor="#02AEFF" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(31 13)">
          <g>
            <path
              fill="#0F754E"
              d="M32.55.016c3.145-.018 12.491-.86 16.45 12.5 2.667 9 6.915 23.743 12.744 44.228h2.373C70.37 35.147 74.663 20.404 77 12.517c4-13.5 14-12.5 18-12.5h30.861v96H94.407V39.441h-2.11L74.763 96.016H51.098L33.564 39.4h-2.11v56.616H0v-96zm138.479 0v56.617h2.509l21.329-46.555C199.007.813 207.83.017 207.83.017h30.439v96h-32.111V39.4h-2.51l-20.91 46.556c-4.14 9.222-13.383 10.06-13.383 10.06h-30.439v-96h32.112zm178.232 45.62c-4.48 12.693-18.546 21.784-34.12 21.784h-33.674v28.597H250.93v-50.38z"
            />
            <path
              fill="url(#linearGradient-1)"
              d="M316.614.017H249.33c1.602 21.373 20.007 39.67 39.061 39.67h62.992c3.635-17.764-8.879-39.67-34.768-39.67z"
            />
          </g>
        </g>
      </g>
    </svg>
  </div>
}

export default MirIcon;
